import React from "react";

const AddToCompositeDevice = ({ color }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20.869" height="24" viewBox="0 0 20.869 24">
			<path
				id="icons8-tree"
				d="M5.5,2a.5.5,0,0,0-.5.5V7.538a.5.5,0,0,0,.5.5h8.056a.5.5,0,0,0,.5-.5V2.5a.5.5,0,0,0-.5-.5ZM9.028,9.049v13.09a.5.5,0,0,0,.5.5h5.538V21.635H10.035V14.083h5.035V13.076H10.035V9.049Zm7.552,1.51a.5.5,0,0,0-.5.5V16.1a.5.5,0,0,0,.5.5h8.056a.5.5,0,0,0,.5-.5V11.062a.5.5,0,0,0-.5-.5Zm.5,1.007h7.049v4.028H17.083Zm-.5,7.552a.5.5,0,0,0-.5.5v5.035a.5.5,0,0,0,.5.5h8.056a.5.5,0,0,0,.5-.5V19.621a.5.5,0,0,0-.5-.5Z"
				transform="translate(-5 -2)"
				fill={color || "#fff"}
			/>
		</svg>
	);
};

export default AddToCompositeDevice;
